import { ChevronRight } from "lucide-react";

export const LIFECYCLE_STAGES = [
  "Procurement", "Fitment", "Operation", "Inspection",
  "Repair", "Refitment", "Performance", "Scrap",
];

export function Lifecycle() {
  return (
    <div data-testid="tyre-lifecycle" className="overflow-x-auto pb-2">
      <div className="flex min-w-[820px]">
        {LIFECYCLE_STAGES.map((stage, i) => (
          <div key={stage} className="relative flex-1 pr-3">
            <div className="h-full border border-white/10 bg-obsidian-2 px-3 py-5 text-center">
              <p className="font-mono text-[10px] tracking-[0.25em] text-ember">
                {String(i + 1).padStart(2, "0")}
              </p>
              <p className="mt-2 font-condensed text-lg font-semibold uppercase tracking-wide text-white">
                {stage}
              </p>
            </div>
            {i < LIFECYCLE_STAGES.length - 1 && (
              <ChevronRight className="absolute -right-1 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-ember" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
